export const OnboardingFormStatus = {
    IN_PROGRESS: 'IN_PROGRESS'
};
